export const outputIndexesGroupingTypesEnum = {
    ByDays: "ByDays",
    ByWeeks: "ByWeeks",
    ByMonths: "ByMonths",
} as const;

export const outputIndexesGroupingTypes = [
    { label: "По дням", value: outputIndexesGroupingTypesEnum.ByDays },
    { label: "По неделям", value: outputIndexesGroupingTypesEnum.ByWeeks },
    { label: "По месяцам", value: outputIndexesGroupingTypesEnum.ByMonths },
];

export const outputIndexesPeriodTypesEnum = {
    LastMonth: "LastMonth",
    LastThreeMonths: "LastThreeMonths",
    LastSixMonths: "LastSixMonths",
    FromStartOfTheYear: "FromStartOfTheYear",
    LastYear: "LastYear",
    LastThreeYears: "LastThreeYears",
    AllTime: "AllTime",
} as const;

export const outputIndexesPeriodTypes = [
    { label: "Последний месяц", value: outputIndexesPeriodTypesEnum.LastMonth },
    { label: "Последние 3 месяца", value: outputIndexesPeriodTypesEnum.LastThreeMonths },
    { label: "Последние 6 месяцев", value: outputIndexesPeriodTypesEnum.LastSixMonths },
    { label: "C начала текущего года", value: outputIndexesPeriodTypesEnum.FromStartOfTheYear },
    { label: "За 1 год", value: outputIndexesPeriodTypesEnum.LastYear },
    { label: "За 3 года", value: outputIndexesPeriodTypesEnum.LastThreeYears },
    { label: "За все время", value: outputIndexesPeriodTypesEnum.AllTime },
];
